<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="5"></ucMenu>
					<div class="right_con">
						<div class="shangjia_main">
							<p class="fb">设置礼金</p>
							<div class="opts_wrap">
								<div class="opts_line">
									<p class="txt">商品ID：</p>
									<div class="con">
										<el-input type="textarea" v-model="formData.productId" placeholder="请输入商品ID,使用英文逗号分隔" style="width: 300px;"></el-input>
									</div>
								</div>
								<div class="opts_line">
									<p class="txt">开始时间：</p>
									<div class="con">
										<el-date-picker
											v-model="formData.startTime"
											type="datetime"
											placeholder="选择开始时间"
											format="yyyy-MM-dd HH:mm:ss"
											value-format="yyyy-MM-dd HH:mm:ss"
											style="width: 300px;">
										</el-date-picker>
									</div>
								</div>
								<div class="opts_line">
									<p class="txt">结束时间：</p>
									<div class="con">
										<el-date-picker
											v-model="formData.endTime"
											type="datetime"
											placeholder="选择结束时间"
											format="yyyy-MM-dd HH:mm:ss"
											value-format="yyyy-MM-dd HH:mm:ss"
											style="width: 300px;">
										</el-date-picker>
									</div>
								</div>
								<div class="btn_wrap">
									<p class="btn" @click="submitForm()">提交</p>
									<p class="btn" @click="resetForm()">重置</p>
								</div>
							</div>
						</div>
						<div class="record_list">
							<div class="record_title">
								<p class="fb">礼金设置记录</p>
							</div>
							<div class="filter_wrap">
								<div class="filter_item">
									<span class="filter_label">店铺筛选：</span>
									<el-select 
										v-model="filterForm.shopId" 
										placeholder="请选择店铺" 
										clearable
										filterable
										style="width: 200px;">
										<el-option
											v-for="shop in shopList"
											:key="shop.shop_id"
											:label="shop.shop_name"
											:value="shop.shop_id">
										</el-option>
									</el-select>
								</div>
								<div class="filter_buttons">
									<el-button type="primary" size="small" @click="searchRecords()">查询</el-button>
									<el-button size="small" @click="resetFilter()">重置</el-button>
								</div>
							</div>
							<div class="table_wrap">
								<el-table :data="recordList" style="width: 100%" stripe>
									<el-table-column  label="店铺ID" width="120" align="center">
										<template slot-scope="scope">
											<p>{{ scope.row.shop.shop_name }}</p>
											<el-button 
												type="text" 
												size="mini" 
												@click="copyShopId(scope.row.shop_id)"
												:title="'点击复制: ' + scope.row.shop_id">
												{{ scope.row.shop_id }}
											</el-button>
										</template>
									</el-table-column>
									<el-table-column label="商品ID" width="120" align="center">
										<template slot-scope="scope">
											<el-button 
												type="text" 
												size="mini" 
												@click="copyProductId(scope.row.product_id)"
												:title="'点击复制: ' + scope.row.product_id">
												复制商品ID
											</el-button>
										</template>
									</el-table-column>
									<el-table-column prop="start_time" label="开始时间" width="180" align="center"></el-table-column>
									<el-table-column prop="end_time" label="结束时间" width="180" align="center"></el-table-column>
									<el-table-column prop="status" label="状态" width="100" align="center">
										<template slot-scope="scope">
											<el-tag :type="scope.row.status === '200' ? 'success' : 'danger'">
												{{ scope.row.status_text }}
											</el-tag>
										</template>
									</el-table-column>
									<el-table-column label="操作" align="center">
										<template slot-scope="scope">
											<el-button type="danger" size="mini" @click="deleteRecord(scope.row)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
								<div class="pagination_wrap">
									<el-pagination
										@size-change="handleSizeChange"
										@current-change="handleCurrentChange"
										:current-page="currentPage"
										:page-sizes="[10, 20, 50, 100]"
										:page-size="pageSize"
										layout="total, sizes, prev, pager, next, jumper"
										:total="total">
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<shopList ref="child"></shopList>
		<myFoot></myFoot>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		mapActions,
		mapState
	} from "vuex";
	import myHead from '../../components/myHead/myhead';
	import myFoot from '../../components/myFoot/myfoot';
	import ucMenu from '../../components/ucenterMenu/ucmenu';
	import shopList from '../../components/shopList/shopList';

	export default {
		name: "ucenterSetGiftMoney",
		data() {
			return {
				// 表单数据
				formData: {
					productId: '',
					startTime: '',
					endTime: ''
				},
				// 筛选表单数据
				filterForm: {
					shopId: ''
				},
				// 记录列表
				recordList: [],
				// 分页数据
				currentPage: 1,
				pageSize: 10,
				total: 0,
				//店铺列表
				shopList: [],
				// 加载状态
				loading: false
			}
		},
		components: {
			myHead,
			myFoot,
			ucMenu,shopList
		},
		computed: {
			...mapState({

			})
		},
		created() {
			this.loadRecordList();
		},
		methods: {
			...mapActions({
				setGiftMoney: "ucenter/setGiftMoney",
				getGiftMoneyList: "ucenter/getGiftMoneyList",
				deleteGiftMoney: "ucenter/deleteGiftMoney",
			}),
			// 提交表单
			submitForm() {
				if (!this.formData.productId) {
					this.$message.error('请输入商品ID');
					return;
				}
				if (!this.formData.startTime) {
					this.$message.error('请选择开始时间');
					return;
				}
				if (!this.formData.endTime) {
					this.$message.error('请选择结束时间');
					return;
				}
				if (new Date(this.formData.startTime) >= new Date(this.formData.endTime)) {
					this.$message.error('结束时间必须大于开始时间');
					return;
				}

				this.setGiftMoney({
					data: {
						productId: this.formData.productId,
						startTime: this.formData.startTime,
						endTime: this.formData.endTime
					},
					success: (res) => {
						this.is_save = false
						if (res.code === 200) {
							// console.log('save celve',res)
							this.$message({
								message: res.msg,
								type: 'success',
							});
						} else {
							this.$message({
								message: res.msg,
								type: 'error',
							});
						}
						this.loadRecordList();
					}
				})
			},
			// 重置表单
			resetForm() {
				this.formData = {
					productId: '',
					startTime: '',
					endTime: ''
				};
			},
			// 加载记录列表
			loadRecordList() {
				this.loading = true;
				// 这里应该调用API获取数据
				// 模拟数据
				setTimeout(() => {
					
					this.getGiftMoneyList({
						data: {
							page: this.currentPage,
							pageSize: this.pageSize,
							shop_id: this.filterForm.shopId || ''
						},
						success: (res) => {
							this.recordList = res.data.list_data.data
							this.total = res.data.list_data.total
							this.shopList = res.data.shop_list
							this.loading = false;
							
						}
					})
				}, 500);
			},
			// 删除记录
			deleteRecord(row) {
				this.$confirm('确定要删除这条记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deleteGiftMoney({
						data: {
							id: row.id
						},
						success: (res) => {
							if (res.code === 200) {
								this.$message({
									message: res.msg || '删除成功',
									type: 'success',
								});
								this.loadRecordList(); // 重新加载列表
							} else {
								this.$message({
									message: res.msg || '删除失败',
									type: 'error',
								});
							}
						},
						error: (err) => {
							this.$message({
								message: '删除失败，请重试',
								type: 'error',
							});
							console.error('删除失败:', err);
						}
					});
				}).catch(() => {
					this.$message.info('已取消删除');
				});
			},
			// 分页大小改变
			handleSizeChange(val) {
				this.pageSize = val;
				this.loadRecordList();
			},
			// 当前页改变
			handleCurrentChange(val) {
				this.currentPage = val;
				this.loadRecordList();
			},
			// 复制商品ID
			copyProductId(productId) {
				if (!productId) {
					this.$message.warning('商品ID为空');
					return;
				}
				
				// 创建临时文本区域元素
				const textArea = document.createElement('textarea');
				textArea.value = productId;
				document.body.appendChild(textArea);
				textArea.select();
				
				try {
					// 执行复制命令
					const successful = document.execCommand('copy');
					if (successful) {
						this.$message.success('商品ID已复制到剪贴板');
					} else {
						this.$message.error('复制失败，请手动复制');
					}
				} catch (err) {
					this.$message.error('复制失败，请手动复制');
				}
				
				// 清理临时元素
				document.body.removeChild(textArea);
			},
			// 复制店铺ID
			copyShopId(shopId) {
				if (!shopId) {
					this.$message.warning('店铺ID为空');
					return;
				}
				
				// 创建临时文本区域元素
				const textArea = document.createElement('textarea');
				textArea.value = shopId;
				document.body.appendChild(textArea);
				textArea.select();
				
				try {
					// 执行复制命令
					const successful = document.execCommand('copy');
					if (successful) {
						this.$message.success('店铺ID已复制到剪贴板');
					} else {
						this.$message.error('复制失败，请手动复制');
					}
				} catch (err) {
					this.$message.error('复制失败，请手动复制');
				}
				
				// 清理临时元素
				document.body.removeChild(textArea);
			},
			// 查询记录
			searchRecords() {
				this.currentPage = 1; // 重置到第一页
				this.loadRecordList();
			},
			// 重置筛选
			resetFilter() {
				this.filterForm.shopId = '';
				this.currentPage = 1; // 重置到第一页
				this.loadRecordList();
			}
		},
	}
</script>

<style lang="less" scoped>
	.wrap .wrap_body {
		display: flex;
		flex-direction: column;
	}

	.center {
		display: flex;
		flex: 1;
	}

	.ucenter_main {
		padding: 30px 0 40px;
		display: flex;
		justify-content: space-between;
		flex: 1;
	}

	.right_con {
		width: 980px;
	}

	.shangjia_main {
		padding: 36px 40px;
		background: #fff;
	}

	.opts_wrap {
		margin-left: 50px;
		padding-top: 14px;
	}

	.opts_wrap .opts_line {
		margin-top: 30px;
		display: flex;
		align-items: center;
	}

	.opts_line .txt {
		width: 140px;
		text-align: right;
		font-size: 14px;
	}
	.opts_line .txt.txt_check {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.opts_line .con {
		flex: 1;
		width: 0;
		margin-left: 22px;
		display: flex;
		align-items: center;
	}

	.opts_line .con .t {
		font-size: 14px;
	}

	.opts_wrap .btn_wrap {
		margin: 40px 0 0 112px;
		display: flex;
	}

	.opts_wrap .btn_wrap .btn {
		width: 80px;
		height: 34px;
		border-radius: 4px;
		display: flex;
		justify-content: center;
		align-items: center;
		margin-right: 14px;
		cursor: pointer;
		box-sizing: border-box;
		font-size: 14px;
	}

	.opts_wrap .btn_wrap .btn:nth-child(1) {
		background: var(--red);
		color: #fff;
	}

	.opts_wrap .btn_wrap .btn:nth-child(2) {
		background: #fff;
		color: #333;
		border: 1px solid #ddd;
	}

	.ml8 {
		margin-left: 8px;
	}

	.w80 {
		width: 80px;
	}

	.shop_list {
		width: auto;
	}

	.shop_list .shop_item {
		border-bottom: 1px solid #ededed;
		padding: 0 10px;
	}
	
	
	.record_list{
		padding: 36px 40px;
		background: #fff;
		margin-top: 20px;
		
		.record_title {
			margin-bottom: 20px;
		}
		
		.filter_wrap {
			display: flex;
			align-items: center;
			margin-bottom: 20px;
			padding: 15px;
			background: #f8f9fa;
			border-radius: 6px;
			
			.filter_item {
				display: flex;
				align-items: center;
				margin-right: 20px;
				
				.filter_label {
					font-size: 14px;
					color: #333;
					margin-right: 10px;
					white-space: nowrap;
				}
			}
			
			.filter_buttons {
				display: flex;
				gap: 10px;
			}
		}
		
		.table_wrap {
			.pagination_wrap {
				margin-top: 20px;
				text-align: right;
			}
		}
	}
	
	// 复制按钮样式
	.el-button--text {
		color: var(--red);
		padding: 0;
		font-size: 14px;
		cursor: pointer;
		
		&:hover {
			color: #ff6b6b;
			text-decoration: underline;
		}
	}
</style>
<style scoped>
	/*red border color*/
	.el-input__inner:focus,
	.el-select .el-input.is-focus .el-input__inner,
	.el-select .el-input__inner:focus,
	.el-radio__input.is-checked .el-radio__inner,
	.el-radio__inner:hover {
		border-color: var(--red);
	}

	/*red color*/
	.el-select-dropdown__item.selected,
	.el-radio__input.is-checked+.el-radio__label {
		color: var(--red);
	}

	/*red background color*/
	.el-radio__input.is-checked .el-radio__inner {
		background-color: var(--red);
	}
</style>